"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PoiMarker = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _map = require("@nicbase/map");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTooltipData = require("nicbase-tooltip-data");

var _tooltip = _interopRequireDefault(require("./tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var PoiMarker = function PoiMarker(_ref) {
  var feature = _ref.feature,
      lat = _ref.lat,
      lng = _ref.lng,
      onMarkerClick = _ref.onMarkerClick;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showGeofence = _useState2[0],
      setShowGeofence = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showTooltip = _useState4[0],
      setShowTooltip = _useState4[1];

  var tooltipRef = (0, _react.useRef)();
  var left = 0;
  var top = 0;

  if (tooltipRef.current) {
    var _tooltipRef$current$g = tooltipRef.current.getBoundingClientRect(),
        width = _tooltipRef$current$g.width;

    var _tooltipRef$current$g2 = tooltipRef.current.getBoundingClientRect();

    left = _tooltipRef$current$g2.left;
    top = _tooltipRef$current$g2.top;
    left += width / 2;
    top -= 4; // for tooltip caret
  }

  var renderPoiType = function renderPoiType() {
    if (feature.properties.waypointType === 'START') {
      // title not visible due to other tooltip
      return /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.MarkerStart, {
        title: "startMarker",
        className: "h-6 w-6 fill-primary"
      });
    } else if (feature.properties.waypointType === 'END') {
      return /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.MarkerEnd, {
        title: "endMarker",
        className: "h-6 w-6 fill-primary"
      });
    }

    return /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.POIWithText, {
      title: "poiMarker",
      type: 120,
      className: "h-6 w-6 fill-primary"
    });
  };

  var memorizedFeatureCollection = (0, _react.useMemo)(function () {
    if (feature.properties.geometry.type === 'Point' && feature.properties.radius) {
      return {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: feature.properties.geometry.coordinates
        },
        properties: {
          radius: feature.properties.radius
        }
      };
    }

    return feature.properties;
  }, [feature]);
  return /*#__PURE__*/_react["default"].createElement(_map.Marker, {
    lat: lat,
    lng: lng
  }, /*#__PURE__*/_react["default"].createElement("div", {
    role: "button",
    className: "inline-flex transform -translate-y-1/2 outline-none shadow-none hover:shadow-none focus:shadow-none",
    ref: tooltipRef,
    tabIndex: 0,
    "aria-label": feature.properties.name,
    onMouseEnter: function onMouseEnter() {
      setShowGeofence(true);
      setShowTooltip(true);
    },
    onFocus: function onFocus() {
      setShowGeofence(true);
      setShowTooltip(true);
    },
    onMouseLeave: function onMouseLeave() {
      setShowGeofence(false);
      setShowTooltip(false);
    },
    onBlur: function onBlur() {
      setShowGeofence(false);
      setShowTooltip(false);
    },
    onClick: function onClick() {
      return onMarkerClick({
        lat: lat,
        lng: lng
      });
    }
  }, renderPoiType(), showGeofence ? /*#__PURE__*/_react["default"].createElement(_map.GeoJson, {
    feature: memorizedFeatureCollection
  }) : null), showTooltip ? /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
    top: top,
    left: left
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTooltipData.PoiData, {
    poi: feature.properties
  })) : null);
};

exports.PoiMarker = PoiMarker;
PoiMarker.propTypes = {
  feature: _propTypes["default"].shape({
    properties: _propTypes["default"].shape({
      id: _propTypes["default"].number,
      name: _propTypes["default"].string,
      waypointType: _propTypes["default"].string,
      radius: _propTypes["default"].number,
      geometry: _propTypes["default"].shape({
        type: _propTypes["default"].string,
        coordinates: _propTypes["default"].arrayOf(_propTypes["default"].number)
      })
    })
  }).isRequired,
  lat: _propTypes["default"].number.isRequired,
  lng: _propTypes["default"].number.isRequired,
  onMarkerClick: _propTypes["default"].func
};
PoiMarker.defaultProps = {
  onMarkerClick: function onMarkerClick() {}
};
var _default = PoiMarker;
exports["default"] = _default;